import { useAccountStore } from "features/Account/store/useAccountStore";
import { getMultiQuestionsAsPerQuestionType } from "../../common/QuestionFormFields/utils/QuestionFormFields.utils";

export const useEditQuestionModal = () => {
  const isEditQuestionModalOpen = useAccountStore(
    (state) => state.isEditQuestionModalOpen
  );

  const setIsEditQuestionModalOpen = useAccountStore(
    (state) => state.setIsEditQuestionModalOpen
  );

  const setQuestionInitialValues = useAccountStore(
    (state) => state.setQuestionInitialValues
  );

  const questionInitialValues = useAccountStore(
    (state) => state.questionInitialValues
  );

  const openEditQuestionmodal = ({ record = {} }) => {
    const question = {
      question: record.question,
      type: record.type,
      is_mandatory: record.is_mandatory,
      choices: record.choices,
      question_uuid: record.uuid,
      is_default: record.is_default,
      question_placement: record.question_placement,
      enable_otp_verification: record?.enable_otp_verification ?? false,
      multi_questions:
        record?.multi_questions ??
        getMultiQuestionsAsPerQuestionType(record.type),
    };
    setQuestionInitialValues(question);
    setIsEditQuestionModalOpen(true);
  };

  const closeEditQuestionModal = () => {
    setIsEditQuestionModalOpen(false);
  };
  return {
    questionInitialValues,
    isEditQuestionModalOpen,
    closeEditQuestionModal,
    openEditQuestionmodal,
  };
};
